// extracted by mini-css-extract-plugin
module.exports = {"title":"DataGrid--title--1tCRQ","row":"DataGrid--row--17LsV","grid-item":"DataGrid--grid-item--3qZYG","gridItem":"DataGrid--grid-item--3qZYG"};